module.exports = __webpack_public_path__ + "static/media/1020072.0ee66a22.png";